import React, { memo } from 'react';
import styled from 'styled-components';
import { MinusIcon, PlusIcon } from '../../../../components/Icons';
import { EditIcon } from '../../../../components/Icons';
import FavouriteIconContainer from '../../../Favourites/FavouriteIcon/FavouriteIconContainer';
import RemoveIcon from '../../../../components/Icons/RemoveIcon';
const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.isForPreview && props.isAuthenticated
      ? '30px 30px 1fr 40px'
      : !props.isForPreview && props.isAuthenticated
      ? '30px 30px  1fr 40px'
      : props.isForPreview && !props.isAuthenticated
      ? '30px 30px 1fr'
      : '30px 30px 1fr'};
  grid-gap: 8px;
  padding: 5px 0;
  align-items: center;
  margin-top: 11px;

  @media (max-width: 786px) {
    grid-template-columns: ${(props) =>
      props.isAuthenticated ? '80px 1fr 1fr' : '80px 1fr'};
  }
`;

const QuantityWrapper = styled.div`
  text-align: center;
  display: grid;
  grid-template-columns: 15px 20px 15px;
  grid-gap: 17px;
`;

const QuantityDiv = styled.span`
  color: ${(props) => props.theme.quantityCartNumber};
`;

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.align === 'end'
      ? 'flex-end'
      : props.align === 'center'
      ? 'center'
      : 'flex-start'};
`;
const ProductEditAndQuantity = ({
  quantity,
  flatProduct,
  handleDecrementProduct,
  handleIncrementProduct,
  handleEditProductConfiguration,
  favouriteId,
  handleToggleProductIsFavourited,
  isForPreview,
  isAuthenticated,
  handleRemoveProductFromCart,
}) => {
  return (
    <Wrapper isForPreview={isForPreview} isAuthenticated={isAuthenticated}>
      <SectionWrapper style={{ marginRight: 'auto' }}>
        <EditIcon
          id='Product-EditProduct'
          onClick={handleEditProductConfiguration}
        />
      </SectionWrapper>
      <SectionWrapper>
        <RemoveIcon
          id='ProductQuantity-EditProduct'
          onClick={handleRemoveProductFromCart}
        />
      </SectionWrapper>
      <SectionWrapper align='end'>
        <QuantityWrapper>
          <div id='Product-DecrementProduct' onClick={handleDecrementProduct}>
            <MinusIcon />
          </div>
          <QuantityDiv>{quantity}</QuantityDiv>
          <div id='Product-IncrementProduct' onClick={handleIncrementProduct}>
            <PlusIcon />
          </div>
        </QuantityWrapper>
      </SectionWrapper>
      {isAuthenticated && (
        <SectionWrapper align='end'>
          <FavouriteIconContainer
            flatProduct={flatProduct}
            isFavourited={favouriteId ? true : false}
            favouriteId={favouriteId}
            addedToFavourites={(favouriteId) =>
              handleToggleProductIsFavourited(favouriteId)
            }
          />
        </SectionWrapper>
      )}
    </Wrapper>
  );
};

export default memo(ProductEditAndQuantity);
